module.exports = __webpack_public_path__ + "static/meet-shawna-fd7b34079f5b4cacf85a3ac64f701c55.jpg";